import "./FilterDateInput.scss";
import moment from "moment";
export default {
  name: "FilterDateInput",
  data: () => ({
    dateModel: "",
    menuModel: false,
    formatedDate: "",
    timeModel: ""
  }),
  mounted() {
    this.initializeDateModels();
  },
  methods: {
    updateValue: function(value) {
      value = value.trim();
      const momentValue = moment.utc(value);
      this.formatedDate = momentValue?.format(this.format) ?? "";
      this.$emit("input", value ? moment.utc(value).toISOString() : "");
    },
    initializeDateModels() {
      this.dateModel = moment(this.value).format("YYYY-MM-DD");
      this.timeModel = moment(this.value).format("HH:mm");
      this.formatedDate = moment(this.value).format(this.format);
      if (this.dateModel.includes("Invalid")) {
        this.dateModel = "";
        this.timeModel = "";
        this.formatedDate = "";
      }
    },
    fillDefault() {
      if (!this.dateModel) this.dateModel = moment().format("YYYY-MM-DD");
      if (!this.timeModel && this.dateTime) this.timeModel = "12:00";
    }
  },
  watch: {
    value: function() {
      this.initializeDateModels();
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: "DD.MM.YYYY"
    },
    dateTime: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  }
};
